import type { DetailPageConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import { taskDetailActions } from "@/lib/actions/definitions/entities";
import type { ContactTaskRow } from "@/lib/types/entity-rows";

// ============================================================================
// ENHANCED TASK DETAIL PAGE CONFIGURATION
// ============================================================================

export const ENHANCED_TASK_DETAIL_CONFIG: DetailPageConfig<ContactTaskRow> = {
  entity: "tasks",
  displayName: "Task",

  // Tab configurations
  tabs: [
    {
      id: "details",
      label: "Details",
      icon: "file-text",
      variant: "blue",
      content: {
        type: "fields",
        layout: "grid",
        sections: [
          {
            id: "main-content",
            title: "Description",
            customComponent: "TaskDescriptionSection",
            layout: "full",
          },
          {
            id: "ai-summary",
            title: "AI Summary",
            customComponent: "TaskAISummary",
            customProps: {
              autoGenerate: false,
              showMetadata: true,
              showRefreshButton: true,
              showClearButton: false,
              compact: false,
            },
          },
          {
            id: "sidebar",
            title: "Task Information",
            customComponent: "TaskInformationSection",
            layout: "sidebar",
            gridColumns: 1,
          },
        ],
      },
    },
    {
      id: "notes",
      label: "Notes",
      icon: "message-square",
      variant: "orange",
      content: {
        type: "notes",
        customComponent: "TaskNotesDisplay",
        customProps: {
          showAddButton: true,
        },
      },
    },
    {
      id: "activity",
      label: "Activity",
      icon: "activity",
      variant: "green",
      content: {
        type: "activity",
        sections: [
          {
            id: "timeline",
            title: "Communication Timeline",
            customComponent: "TaskActivityTimeline",
          },
        ],
      },
    },
    {
      id: "company",
      label: "Company",
      icon: "building",
      variant: "red",
      content: {
        type: "related",
        sections: [
          {
            id: "company-info",
            title: "Company Information",
            customComponent: "TaskCompanyDisplay",
          },
        ],
      },
    },
    {
      id: "contact",
      label: "Contact",
      icon: "user",
      variant: "purple",
      content: {
        type: "related",
        sections: [
          {
            id: "contact-info",
            title: "Contact Information",
            customComponent: "TaskContactDisplay",
          },
        ],
      },
    },
  ],

  // Action configurations - from centralized registry
  actions: taskDetailActions,

  // Breadcrumb configuration
  breadcrumbs: {
    show: true,
    items: [
      { label: "Tasks", href: "/tasks" },
      {
        label: "Task Details",
        href: (task: ContactTaskRow) => `/tasks/${task.id}`,
        current: true,
      },
    ],
  },

  // Page configuration
  defaultTab: "details",
  showHeader: true,
  showBreadcrumbs: true,
  showActions: true,

  // Title and description templates
  titleTemplate: "{title}",
  descriptionTemplate: "Task Details",
};
